import type { ADFEntity } from '@atlaskit/adf-utils/types';

import type { BlocksSnippetAri } from '@atlassian/ari';

export enum SnippetProduct {
	// Only Confluence is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	CONFLUENCE = 'CONFLUENCE',
}
export enum SnippetBodyFormat {
	// Only ADF is allowed currently but more will be added:
	// 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
	ADF = 'ADF',
}

export enum SnippetStatus {
	ACTIVE = 'active',
	DELETED = 'deleted',
}

export type SnippetOwner =
	| {
			accountId: string;
			displayName: string;
	  }
	| {
			accountId: 'atlassian';
			displayName: 'Atlassian';
	  };

// Transformed snippet data from the block service
export type Snippet = {
	ari: BlocksSnippetAri;
	snippetId: string; // uuidv7
	name: string;
	description?: string;
	bodyFormat: SnippetBodyFormat;
	body?: ADFEntity | ADFEntity[]; // Could be undefined if parsing the body failed
	product: SnippetProduct;
	label?: string;
	isFavorite: boolean;
	status: SnippetStatus;
	createdBy: SnippetOwner;
	createdAt: Date;
	updatedAt: Date;
};
